import React, { forwardRef } from 'react'
import BaseModal from 'components/BaseModal'
import _ from 'lodash'
import { Typography, Alert } from 'antd'

const { Text, Paragraph, Link } = Typography;

export default forwardRef(function IngestionScriptSuccessInstructions({ afterClose, token, fileName, downloadFileType }, ref) {
    const modalProps = {
        footer: null
    }
    
    const warningText = <>Open the script & copy paste your ArmorCode API key <br /><br /> <Text code>{`api_key = '<<please_insert_api_key_here>>'`}</Text></>

    return (
        <BaseModal
            modalProps={modalProps}
            ref={ref}
            afterClose={afterClose}
        >
            <Paragraph>
                A {downloadFileType || "Python"} file with name <Text strong>{fileName}</Text> has been downloaded.
            </Paragraph>
            <Alert type="warning" showIcon message ={warningText} />
            <br />
            {
                !_.isEmpty(token)
                ?
                <Paragraph>
                    Your <Text strong>ArmorCode API key</Text> is <Text copyable={{ text: token.value }} >***************{token.value.substr(token.value.length - 4, 4)}</Text>
                    <br />
                    <Link href={`data:text/plain;charset=utf-8,${token.value}`} download={`ArmorCode_API_key(${token.name}).txt`}>Download key</Link>
                </Paragraph>
                :
                null
            }
        </BaseModal>
    )
})
